import React from 'react';
import { Field, reduxForm } from 'redux-form';
import ModalBox from '../../../../shared/modal';
import SelectField from '../../../../shared/form-elements/select/field';
import InputField from '../../../../shared/form-elements/input';

const ProlongRequest = props =>
	<ModalBox
		title={props.intl('Изменение даты окончания гаранта № ' + props.prolongPopupRequestId)}
		body={PopupContent(props)}
		isOpen={props.isOpen}
		onClose={props.togglePopup}
	/>;

const PopupContent = props => {
	return (
		<div className="adv-request__wrap">
			<form
				onSubmit={props.handleSubmit(props.prolong.bind(null, props.prolongPopupRequestId))}
			>
				<Field
					name="prolong_type"
					searchable={false}
					component={SelectField}
					placeholder="Type"
					options={props.prolongRequestTypes}
				/>
				<Field
					name="prolong_reason"
					searchable={false}
					component={SelectField}
					placeholder="Reason"
					options={props.prolongRequestReasons}
				/>
				<Field
					name="prolong_comment"
					searchable={false}
					component={InputField}
					placeholder="Comment"
				/>
				<button
					className="ui-btn ui-btn-primary save margin-top-120"
				>
					{props.intl('Submit')}
				</button>
			</form>
		</div>
	);
};

export default reduxForm({
	form: 'affiliateCredentialsForm'
})(ProlongRequest);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/limited-garants/list/components/forms/prolong-request.js